import { SubjectManager } from "../utils/subject-manager";

export type LocationEvent = {  // Make sure to export the type
  type: "LOCATION_CHANGED";
  payload: string | null;
};

export const locationEventsService = new SubjectManager<LocationEvent>();